import {db} from '../../FireBase/base';
import {addDoc, collection} from "firebase/firestore";

const CONTACT = 'contact'

export const saveBlog = async (message) => {
    const docRef = await addDoc(collection(db, CONTACT), message);
    return docRef.id;

}